// src/ContextApi/PwaPromptContext.js  (فایل جدید)

import React, { createContext, useContext, useState, useEffect } from 'react';

// 1. ساخت کانتکست
const PwaPromptContext = createContext(null);

// 2. ساخت هوک سفارشی برای استفاده آسان از کانتکست
export const usePwaPrompt = () => useContext(PwaPromptContext);

// 3. ساخت Provider که تمام منطق را در خود دارد
export const PwaPromptProvider = ({ children }) => {
  const [prompt, setPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const userChoice = sessionStorage.getItem('pwaInstallDismissed');
    if (userChoice === 'true') {
      return;
    }

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setPrompt(event);
      setShowBanner(true);
      
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    const handleAppInstalled = () => {
      setShowBanner(false);
      setPrompt(null);
    
    };

    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem('pwaInstallDismissed', 'true');
    setShowBanner(false);
  };

  const handleInstall = () => {
    if (!prompt) return;

    prompt.prompt();
    prompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        // console.log('User accepted the A2HS prompt');
      }
      setShowBanner(false);
      setPrompt(null);
    });
  };

  const value = { showBanner, handleInstall, handleDismiss };

  return (
    <PwaPromptContext.Provider value={value}>
      {children}
    </PwaPromptContext.Provider>
  );
};